// src/pages/AntiAgingHabits.js
import React from 'react';
import './AntiAgingHabits.css';
import { ReactComponent as ArrowIcon } from '../assets/icons/arrow.svg';
import effect1 from '../assets/effect1.png';
import effect2 from '../assets/effect2.png';
import effect3 from '../assets/effect3.png';
import effect4 from '../assets/effect4.png';
import effect5 from '../assets/effect5.png';

export default function AntiAgingHabits() {
  const habits = [
    {
      titleDesktop: <>아침 햇빛 + 만보 걷기</>,
      titleMobile: <>아침 햇빛 + 만보 걷기</>,
      items: [
        { desktop: <>기상 후 30분 이내 햇빛 쬐기</>, mobile: <>기상 후 30분 이내 햇빛 쬐기</> },
        {
          desktop: <>하루 총 10,000보 걷기 목표<br/>(나누어 걸어도 OK)</>,
          mobile: <>하루 총 10,000보 걷기 목표<br/>(나누어 걸어도 OK)</>
        },
        {
          desktop: <>추천: 동네 산책, 시장보기, 계단 이용 등<br/>일상 속 실천</>,
          mobile: <>추천: 동네 산책, 시장보기, 계단 이용<br/>일상 속 실천</>
        },
      ],
      effectDesktop: '심혈관 건강, 우울감 완화, 수면 리듬 조절',
      effectMobile: <>심혈관 건강, 우울감 완화,<br/>수면 리듬 조절</>,
      img: effect1,
    },
    {
      titleDesktop: <>식사는 천천히, 꼭꼭 씹기</>,
      titleMobile: <>식사는 천천히, 꼭꼭 씹기</>,
      items: [
        { desktop: <>하루 2~3회 식사를 규칙적으로 하기</>, mobile: <>하루 2~3회 식사를 규칙적으로 하기</> },
        {
          desktop: <>한 끼 20분 이상, 한 입 30회 이상 씹기<br/>실천</>,
          mobile: <>한 끼 20분 이상, 한 입 30회 이상<br/>씹기 실천</>
        },
      ],
      effectDesktop: '과식 방지, 소화 촉진, 대사 건강에 도움',
      effectMobile: <>과식 방지, 소화 촉진,<br/>대사 건강에 도움</>,
      img: effect2,
    },
    {
      titleDesktop: <>디지털 체험 학습 30분</>,
      titleMobile: <>디지털 체험 학습 30분</>,
      items: [
        {
          desktop: <>스마트폰 활용, 사진 편집, ChatGPT와<br/>유튜브 강의 시청 등</>,
          mobile: <>스마트폰 활용, 사진 편집, 유튜브와<br/>ChatGPT 강의 시청 등</>
        },
        {
          desktop: <>하루 1가지 디지털 도구를 직접 사용해<br/>보기</>,
          mobile: <>하루 1가지 디지털 도구를 직접<br/>사용해 보기</>
        },
      ],
      effectDesktop: '뇌 자극, 정보 활용 능력 향상, 디지털 소외 방지',
      effectMobile: <>뇌 자극, 정보 활용 능력 향상,<br/>디지털 소외 방지</>,
      img: effect3,
    },
    {
      titleDesktop: <>하루 1회 커뮤니티 접속</>,
      titleMobile: <>하루 1회 커뮤니티 접속</>,
      items: [
        {
          desktop: <>하루 한 번 EverYoung Life 커뮤니티에<br/>접속해 출석 체크 / 글 남기기 / 댓글 달기<br/>/ 활동 인증</>,
          mobile: <>하루 한 번 EverYoung Life<br/>커뮤니티에 접속해 출석 체크 /<br/>글 남기기 / 댓글 달기 / 활동 인증</>
        },
      ],
      effectDesktop: '사회적 유대감 강화, 활동 지속 동기 부여',
      effectMobile: <>사회적 유대감 강화,<br/>활동 지속 동기 부여</>,
      img: effect4,
    },
    {
      titleDesktop: <>책 읽기 또는 글쓰기</>,
      titleMobile: <>책 읽기 또는 글쓰기</>,
      items: [
        { desktop: <>하루 10분 이상 책 읽기</>, mobile: <>하루 10분 이상 책 읽기</> },
        {
          desktop: <>또는 오늘 느낀 점, 기억, 루틴에 대한<br/>글쓰기</>,
          mobile: <>또는 오늘 느낀 점, 기억, 루틴에 대한<br/>글쓰기</>
        },
      ],
      effectDesktop: '인지 능력 향상, 감정 안정, 자기 표현 강화',
      effectMobile: <>인지 능력 향상, 감정 안정,<br/>자기 표현 강화</>,
      img: effect5,
    },
  ];

  return (
    <div className="habits-page">
      <h1 className="page-title">
        <span className="only-desktop">저속 노화를 위한 하루 습관 5가지</span>
        <span className="only-mobile">
          저속 노화를 위한<br/>
          하루 습관 5가지
        </span>
      </h1>

      {habits.map((h, i) => (
        <div className="habit-section" key={i}>
          {/* 텍스트 박스 */}
          <div className="aa-feature-box">
            <h2 className="habit-title">
              <span className="only-desktop">{h.titleDesktop}</span>
              <span className="only-mobile">{h.titleMobile}</span>
            </h2>
            <ul>
              {h.items.map((it, j) => (
                <li key={j}>
                  <span className="only-desktop">{it.desktop}</span>
                  <span className="only-mobile">{it.mobile}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* 화살표 */}
          <div className="arrow-container">
            <ArrowIcon className="arrow-icon" />
          </div>

          {/* 효과 카드 */}
          <div className="effect-card">
            <img src={h.img} alt="효과 이미지" />
            <p className="effect-caption">
              <span className="only-desktop">효과: {h.effectDesktop}</span>
              <span className="only-mobile">효과: {h.effectMobile}</span>
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}
